const PATIENT_EXPERIENCE_USER_NAME = "Patient";

export const isPatientExperienceUser = (user) => Boolean(user?.isPatientExperienceUser);

export const formatName = (user) => {
  if (!user) return user;
  if (isPatientExperienceUser(user)) return PATIENT_EXPERIENCE_USER_NAME;
  const firstName = user.firstName ?? "";
  const lastName = user.lastName ?? "";
  return `${firstName} ${lastName}`.trim() || null;
};
